import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "label", "labelOn", "iconOff", "iconOn", "description", "descriptionOn"]

  connect() {
    this.update()
  }

  change() {
    this.update()
  }

  update() {
    const isChecked = this.checkboxTarget.checked

    if (this.hasLabelTarget) {
      this.labelTarget.classList.toggle("hidden", isChecked)
    }
    if (this.hasLabelOnTarget) {
      this.labelOnTarget.classList.toggle("hidden", !isChecked)
    }
    if (this.hasIconOffTarget) {
      this.iconOffTarget.classList.toggle("hidden", isChecked)
    }
    if (this.hasIconOnTarget) {
      this.iconOnTarget.classList.toggle("hidden", !isChecked)
    }
    if (this.hasDescriptionTarget) {
      this.descriptionTarget.classList.toggle("hidden", isChecked)
    }
    if (this.hasDescriptionOnTarget) {
      this.descriptionOnTarget.classList.toggle("hidden", !isChecked)
    }
  }
}
